import { clientsTypes } from "../constants/action-types"

const initialState = {
   firmsCustomerData: [],
    firmsCustomerLoading: false,
    firmsCustomerError: null
}

export const clientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case clientsTypes.CLIENTS_GET_FIRMS_CUSTOMER:
            return {
                ...state,
                firmsCustomerData: action.payload,
                firmsCustomerLoading: false,
                firmsCustomerError: null
            }
            default: return state
    }
}
export default clientsReducer
